import type { ITournamentSchedule, IDaySchedule } from '../../../../types/schedule';
import {
  type FilterItem,
  pureFilterScheduleBy,
} from './schedule.helpers';

type SliceDisplayViewCache = {
  filteredSchedule: ITournamentSchedule;
  selectedDayKey: number;
  dayRef: IDaySchedule;
  view: ITournamentSchedule;
};

let sliceDisplayViewCache: SliceDisplayViewCache | null = null;

export function clearDisplayScheduleViewCache() {
  sliceDisplayViewCache = null;
}

export function resolveScheduleDayKey(
  schedule: ITournamentSchedule | null,
  selectedDayKey: number
): number {
  if (!schedule?.days?.length) return selectedDayKey;
  if (schedule.days.some((d) => d.dayKey === selectedDayKey)) return selectedDayKey;
  return schedule.days[0].dayKey;
}

export function deriveDisplayScheduleView(
  schedule: ITournamentSchedule | null,
  filters: FilterItem[],
  selectedDayKey: number
): ITournamentSchedule | null {
  if (!schedule || schedule.days.length === 0) {
    sliceDisplayViewCache = null;
    return null;
  }

  const filteredSchedule = pureFilterScheduleBy(schedule, filters);

  const day = filteredSchedule.days.find((d) => d.dayKey === selectedDayKey);
  if (!day) {
    sliceDisplayViewCache = null;
    return null;
  }

  if (
    sliceDisplayViewCache &&
    sliceDisplayViewCache.filteredSchedule === filteredSchedule &&
    sliceDisplayViewCache.selectedDayKey === selectedDayKey &&
    sliceDisplayViewCache.dayRef === day
  ) {
    return sliceDisplayViewCache.view;
  }

  const view = { ...filteredSchedule, days: [day] };
  sliceDisplayViewCache = {
    filteredSchedule,
    selectedDayKey,
    dayRef: day,
    view,
  };
  return view;
}
